import { gql } from "apollo-boost"

export default gql`
  mutation SendContactForm($input: ContactSubmissionInputType!) {
    sendContactForm(contactSubmission: $input) {
      ok
    }
  }
`
